import React from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';

// ---------------------------------------------------------------------------
// ToolbarGroup
// ---------------------------------------------------------------------------

export const ToolbarGroup: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Stack direction="row" spacing={0.5} alignItems="center">
    {children}
  </Stack>
);

// ---------------------------------------------------------------------------
// ToolbarButton
// ---------------------------------------------------------------------------

export interface ToolbarButtonProps {
  title: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  active?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}

export const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  title,
  onClick,
  active = false,
  disabled = false,
  children,
}) => (
  <Tooltip title={title}>
    <span>
      <IconButton
        size="small"
        onClick={onClick}
        disabled={disabled}
        sx={{
          width: 34,
          height: 34,
          borderRadius: 1,
          color: active ? '#0b57d0' : '#444746',
          bgcolor: active ? '#e8f0fe' : 'transparent',
          border: active ? '1px solid #c6dafc' : '1px solid transparent',
          '&:hover': {
            bgcolor: active ? '#d2e3fc' : 'rgba(60,64,67,0.08)',
          },
        }}
      >
        {children}
      </IconButton>
    </span>
  </Tooltip>
);
